import { render, staticRenderFns } from "./CharacterSheetNotes.vue?vue&type=template&id=462abf7e&lang=pug&"
import script from "./CharacterSheetNotes.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports